import React from 'react'

import './NewPortalAlert.scss'
import { Heading5 } from '@entur/typography'
import { ExternalIcon, WarningIcon } from '@entur/icons'
import { Button } from '@entur/button'
import { Link } from 'docz'

const NewPortalAlert = () => {
    return (
        <div className="new-portal-alert">
            <div className="icon">
                <WarningIcon size={32} />
            </div>
            <div className="text">
                <Heading5 margin="none">
                    This is the old developer portal
                </Heading5>
                <p>
                    Entur&apos;s developer portal has moved to{' '}
                    <Link to="https://developer.entur.no">
                        developer.entur.no
                    </Link>
                    . Use the new portal for the latest documentation. This old
                    version will be retired once its content has moved, but API
                    changes are still published here for now, under{' '}
                    <Link to="/pages-intro-news">News and Notifications</Link>.
                </p>
            </div>
            <div className="button">
                <Link to="https://developer.entur.no">
                    <Button variant="primary">
                        Go to new developer portal <ExternalIcon />
                    </Button>
                </Link>
            </div>
        </div>
    )
}

export default NewPortalAlert
